import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Segment, Label, Button } from 'semantic-ui-react';
import { TagEditor, GroupEditor } from '../containers/index';
import { tagType } from '../types';
import './styles/TagView.css';

const propTypes = {
  tagGroups: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isReqruied,
    tags: PropTypes.arrayOf(tagType).isrequired,
  })).isRequired,
  tagSearchText: PropTypes.string.isRequired,
  tagEditorOpen: PropTypes.bool.isRequired,
  openTagEditor: PropTypes.func.isRequired,
  groupEditorOpen: PropTypes.bool.isRequired,
  openGroupEditor: PropTypes.func.isRequired,
};

function highlight(text, searchStr) {
  const commaString = text.replace(
    new RegExp(`(${searchStr})`, 'gi'),
    (match, p1, offset, string) => {
      if (offset === 0) return `${match},`;
      if (offset + match.length < string.length) return `,${match},`;
      return `,${match}`;
    },
  );
  return commaString.split(',').map((str, index) => {
    if (str.toLowerCase() === searchStr.toLowerCase()) {
      return (
        <span key={searchStr + index} style={{ backgroundColor: 'rgba(255,255,0,0.3)' }}>{str}</span>
      );
    }
    return <span key={searchStr + index}>{str}</span>;
  });
}

class TagView extends Component {
  componentWillMount() {
    this.setState({
      resultsCount: 50,
    });
  }
  render() {
    const {
      tagGroups,
      tagSearchText,
      tagEditorOpen,
      openTagEditor,
      groupEditorOpen,
      openGroupEditor,
    } = this.props;
    const { resultsCount } = this.state;
    return (
      <div id="tag-table">
        {tagEditorOpen ? <TagEditor /> : null}
        {groupEditorOpen ? <GroupEditor /> : null}
        {tagGroups.slice(0, resultsCount).map(tagGroup => (
          <Segment
            raised
            key={tagGroup._id}
          >
            <Label
              as="a"
              color="teal"
              size="big"
              ribbon
              onClick={() => { openGroupEditor({ group: tagGroup, isNew: false }); }}
            >
              {highlight(tagGroup.name, tagSearchText)}
            </Label>
            <Label
              as="a"
              color="green"
              corner="right"
              icon="add"
              onClick={() => {
                openTagEditor({
                  tag: {
                    group: tagGroup._id,
                  },
                  isNew: true,
                });
              }}
            />
            {tagGroup.tags.map(tag => (
              <Button
                key={`${tagGroup._id}.${tag._id}`}
                size="tiny"
                content={highlight(tag.display, tagSearchText)}
                icon="edit"
                labelPosition="right"
                onClick={() => { openTagEditor({ tag, isNew: false }); }}
              />
            ))}
          </Segment>
        ))}
        {tagGroups.length > resultsCount ?
          <Button
            onClick={() => {
              this.setState({ resultsCount: resultsCount + 50 });
            }}
          >
            Show 50 more results
          </Button>
          : null
        }
      </div>
    );
  }
}

TagView.propTypes = propTypes;
export default TagView;



// WEBPACK FOOTER //
// ./src/components/TagView.jsx